/* Ardor Printing AI banner generator (sections/ardor-banner-idea.liquid, template page.ai-banner-generator). 2026-10-08.
   Same look, Turnstile and email-unlock flow as the AI sticker idea generator (assets/ardor-idea.js), and the same
   visitor id + email (localStorage wsIdeaVisitor / wsIdeaEmail), so one email unlocks both generators.
   Worker routes (see banner-ai CONTRACT.md): /api/banner/quota, /logo, /generate, /fix, /final.
   "Use this design" -> /api/banner/final -> <builder>?ai=<finalId>&w=<ft>&h=<ft>[&logo=<logoId>][&lb=x0,y0,x1,y1][&ends=smooth].
   Busy-edged designs on banners wider than 3:1 (taller than 1:3) first ask "How should we fill the ends?" (smooth or stretched).
   Before redirecting it fires a cancelable "ardor:banner-ai-handoff" event on the section (detail.url);
   calling preventDefault() on it stops the redirect (used by the local test harness).
   No jQuery and no libraries except Cloudflare Turnstile. */
(function () {
  'use strict';
  const root = document.querySelector('[data-ardor-banner-ai]');
  if (!root || root.dataset.abiReady) return;
  root.dataset.abiReady = '1';

  const $ = (s, c = root) => c.querySelector(s);
  const $$ = (s, c = root) => Array.from(c.querySelectorAll(s));
  const API = (root.dataset.api || '').replace(/\/+$/, '');
  const SITEKEY = root.dataset.turnstile || '';
  const BUILDER = root.dataset.builder || '/products/custom-printed-130z-outdoor-banners';
  const MIN_FT = 1;
  const MAX_FT = 100;
  const MAX_LOGO_PX = 1536;
  const MAX_LOGO_BYTES = 8 * 1024 * 1024;
  const MAX_SOURCE_BYTES = 30 * 1024 * 1024;
  const LIMITS = { headline: 60, subline: 80, details: 120, notes: 300, fix: 200 };
  const STYLES = { bold: 'Bold', clean: 'Clean', fun: 'Fun', elegant: 'Elegant', vintage: 'Vintage', event: 'Event' };
  const LAST_KEY = 'ardorBannerAiLast';
  const PICK_KEY = 'ardorBannerAiPick';
  // [seconds, status text, step index (Layout, Your words, Spell check, Final touches), only when]
  const GEN_STEPS = [
    [0, 'Laying out your banner…', 0],
    [10, 'Setting your words…', 1],
    [22, 'Placing your logo…', 1, 'logo'],
    [34, 'Checking the spelling…', 2],
    [50, 'Double-checking every word…', 2],
    [66, 'Adding the final touches…', 3],
    [82, 'Almost there…', 3]
  ];

  /* ---------- storage (same keys as the sticker generator for visitor + email) ---------- */
  const store = {
    get(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } },
    set(k, v) { try { window.localStorage.setItem(k, v); } catch (e) { /* private mode */ } }
  };
  const sget = (k) => { try { return JSON.parse(window.sessionStorage.getItem(k) || 'null'); } catch (e) { return null; } };
  const sset = (k, v) => { try { window.sessionStorage.setItem(k, JSON.stringify(v)); } catch (e) { /* full or blocked */ } };

  let visitor = store.get('wsIdeaVisitor');
  if (!visitor || !/^[a-zA-Z0-9_-]{8,64}$/.test(visitor)) {
    visitor = (window.crypto && crypto.randomUUID ? crypto.randomUUID() : String(Date.now()) + Math.random().toString(36).slice(2)).replace(/[^a-zA-Z0-9_-]/g, '');
    store.set('wsIdeaVisitor', visitor);
  }
  let email = store.get('wsIdeaEmail') || '';

  function track(name, data) {
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data || {}); } catch (e) { /* ignore */ }
  }

  /* ---------- elements ---------- */
  const form = $('[data-abi-form]');
  const wIn = $('[data-abi-w]');
  const hIn = $('[data-abi-h]');
  const chips = $$('.abi__chip');
  const shapeBox = $('[data-abi-shape-box]');
  const shapeLabel = $('[data-abi-shape-label]');
  const sizeNote = $('[data-abi-size-note]');
  const sizeErr = $('[data-abi-size-err]');
  const drop = $('[data-abi-drop]');
  const fileIn = $('[data-abi-file]');
  const logoRow = $('[data-abi-logo]');
  const logoImg = $('[data-abi-logo-img]');
  const logoName = $('[data-abi-logo-name]');
  const logoInfo = $('[data-abi-logo-info]');
  const logoErr = $('[data-abi-logo-err]');
  const lineIns = { headline: $('[data-abi-line="headline"]'), subline: $('[data-abi-line="subline"]'), details: $('[data-abi-line="details"]') };
  const headErr = $('[data-abi-headline-err]');
  const notesIn = $('[data-abi-notes]');
  const styleBtns = $$('[data-style]');
  const goBtn = $('[data-abi-go]');
  const goLabel = $('[data-abi-go-label]');
  const quotaEl = $('[data-abi-quota]');
  const errEl = $('[data-abi-err]');
  const results = $('[data-abi-results]');
  const metaEl = $('[data-abi-meta]');
  const echo = $('[data-abi-echo]');
  const h2 = $('[data-abi-h2]');
  const statusEl = $('[data-abi-status]');
  const loading = $('[data-abi-loading]');
  const bar = $('[data-abi-bar]');
  const stepEls = $$('[data-abi-steps] li');
  const grid = $('[data-abi-grid]');
  const againRow = $('[data-abi-again-row]');
  const againBtn = $('[data-abi-again]');
  const editBtn = $('[data-abi-edit]');
  const fineEl = $('.abi__fine');
  const gate = $('[data-abi-gate]');
  const gateForm = $('[data-abi-gate-form]');
  const gateEmail = $('[data-abi-email]');
  const gateErr = $('[data-abi-gate-err]');
  const gateN = $('[data-abi-gate-n]');

  const S = {
    w: 6, h: 3, style: 'bold',
    logo: null, // { blob, w, h, name, id, thumb (object URL or data URL), thumbData }
    batch: null, // { batchId, aspect, clamped, w, h, style, notes, lines, logoId, images }
    busy: false, off: false,
    bannersLeft: null, fixesLeft: null, finalsLeft: null,
    hasEmail: !!email, freeBanners: 2, emailBanners: 10,
    pending: null
  };

  if (!API) {
    goBtn.disabled = true;
    quotaEl.hidden = true;
    return;
  }

  /* ---------- small helpers ---------- */
  const clean = (s) => String(s || '').replace(/\s+/g, ' ').trim();
  const round2 = (n) => Math.round(n * 100) / 100;
  const fmt = (n) => String(round2(n));
  const sizeLabel = (w, h) => `${fmt(w)} x ${fmt(h)} ft`;
  const num = (v) => { const n = parseFloat(String(v).replace(',', '.')); return Number.isFinite(n) ? n : NaN; };
  const validFt = (n) => Number.isFinite(n) && n >= MIN_FT && n <= MAX_FT;
  const clampAr = (a) => Math.min(3, Math.max(1 / 3, a));
  const shapeOf = (a) => (a >= 6 ? 'xwide' : a >= 1.3 ? 'wide' : a > 0.77 ? 'square' : 'tall');
  const enc = encodeURIComponent;

  function showErr(msg, el = errEl) { el.textContent = msg || ''; el.hidden = !msg; }
  function setInvalid(el, bad) { if (bad) el.setAttribute('aria-invalid', 'true'); else el.removeAttribute('aria-invalid'); }
  function withEmail(body) { if (S.hasEmail && email) body.email = email; return body; }

  function setQuota() {
    if (S.bannersLeft == null) return;
    const n = S.bannersLeft;
    const s = n === 1 ? '' : 's';
    if (S.hasEmail) quotaEl.textContent = n > 0 ? `${n} tr${n === 1 ? 'y' : 'ies'} left today` : 'No tries left today';
    else quotaEl.textContent = n > 0 ? `${n} free tr${n === 1 ? 'y' : 'ies'} · 4 designs each · no sign-up` : `Add your email for ${S.emailBanners} tries a day`;
    if (gateN) gateN.textContent = String(S.emailBanners);
    $$('.abi__fix-left', grid).forEach((el) => { el.textContent = fixesText(); });
  }
  function fixesText() {
    if (S.fixesLeft == null) return '';
    return `${S.fixesLeft} fix${S.fixesLeft === 1 ? '' : 'es'} left today`;
  }

  /* ---------- API ---------- */
  async function api(path, body, timeoutMs = 180000) {
    const opts = {};
    if (body instanceof FormData) { opts.method = 'POST'; opts.body = body; }
    else if (body) { opts.method = 'POST'; opts.headers = { 'Content-Type': 'application/json' }; opts.body = JSON.stringify(body); }
    let timer = 0;
    if (window.AbortController) {
      const ctl = new AbortController();
      opts.signal = ctl.signal;
      timer = setTimeout(() => ctl.abort(), timeoutMs);
    }
    let r;
    try {
      r = await fetch(API + path, opts);
    } catch (e) {
      clearTimeout(timer);
      if (e && e.name === 'AbortError') return { ok: false, error: 'timeout', message: 'This is taking longer than usual. Please try again.' };
      return { ok: false, error: 'network', message: 'Check your connection and try again.' };
    }
    let j = {};
    try { j = await r.json(); } catch (e) { j = {}; }
    clearTimeout(timer);
    if (!j || typeof j !== 'object') j = {};
    if (r.status === 402 && !j.error) j.error = 'need_email';
    if (!r.ok) {
      if (!j.error) j = { ok: false, error: 'server', message: 'Something went wrong on our side. Please try again.' };
      j.ok = false;
    }
    return j;
  }

  /* ---------- Turnstile (same approach as the sticker generator: explicit render, invisible, fresh token per POST) ---------- */
  let tsReady = null;
  let tsWidget = null;
  let tsResolve = null;
  function loadTurnstile() {
    if (!SITEKEY) return Promise.resolve(false);
    if (tsReady) return tsReady;
    tsReady = new Promise((res) => {
      if (window.turnstile && window.turnstile.render) { res(true); return; }
      window.abiTurnstileLoaded = () => res(true);
      const s = document.createElement('script');
      s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit&onload=abiTurnstileLoaded';
      s.async = true;
      s.defer = true;
      s.onerror = () => res(false);
      document.head.appendChild(s);
    });
    return tsReady;
  }
  async function botToken() {
    if (!SITEKEY || !(await loadTurnstile()) || !window.turnstile) return '';
    return new Promise((res) => {
      tsResolve = res;
      const take = (t) => { const r = tsResolve; if (r) { tsResolve = null; r(t || ''); } };
      try {
        if (tsWidget === null) {
          tsWidget = window.turnstile.render($('[data-abi-turnstile]'), {
            sitekey: SITEKEY,
            execution: 'execute',
            appearance: 'interaction-only',
            callback: (t) => take(t),
            'error-callback': () => take('')
          });
        } else {
          window.turnstile.reset(tsWidget);
        }
        window.turnstile.execute(tsWidget);
      } catch (e) { take(''); }
      setTimeout(() => { if (tsResolve === res) take(''); }, 45000);
    });
  }

  /* ---------- size ---------- */
  function readSize() { return { w: num(wIn.value), h: num(hIn.value) }; }
  function syncSize() {
    const { w, h } = readSize();
    const ok = validFt(w) && validFt(h);
    chips.forEach((c) => c.setAttribute('aria-pressed', String(ok && Number(c.dataset.w) === round2(w) && Number(c.dataset.h) === round2(h))));
    if (!ok) return;
    S.w = round2(w);
    S.h = round2(h);
    setInvalid(wIn, false);
    setInvalid(hIn, false);
    showErr('', sizeErr);
    const ar = S.w / S.h;
    const art = clampAr(ar);
    const ext = Math.abs(ar - art) > 0.001;
    shapeBox.style.setProperty('--ar', String(ar));
    shapeBox.style.setProperty('--art', String(art));
    shapeBox.classList.toggle('is-ext', ext);
    shapeBox.classList.toggle('is-ext-w', ext && ar > 3);
    shapeBox.classList.toggle('is-ext-h', ext && ar < 1);
    shapeLabel.textContent = sizeLabel(S.w, S.h);
    if (ext) {
      sizeNote.textContent = ar > 3
        ? `Wider than 3:1, so we'll design it at 3:1 and extend the background to your full ${sizeLabel(S.w, S.h)} size.`
        : `Taller than 1:3, so we'll design it at 1:3 and extend the background to your full ${sizeLabel(S.w, S.h)} size.`;
    } else {
      sizeNote.textContent = 'Your designs come back in this exact shape.';
    }
  }
  function setSize(w, h) { wIn.value = fmt(w); hIn.value = fmt(h); syncSize(); }
  [wIn, hIn].forEach((el) => {
    el.addEventListener('input', syncSize);
    el.addEventListener('blur', () => {
      const v = num(el.value);
      if (Number.isFinite(v)) { el.value = fmt(Math.min(MAX_FT, Math.max(MIN_FT, v))); syncSize(); }
    });
  });
  chips.forEach((c) => c.addEventListener('click', () => setSize(Number(c.dataset.w), Number(c.dataset.h))));
  $('[data-abi-swap]').addEventListener('click', () => {
    const { w, h } = readSize();
    wIn.value = Number.isFinite(h) ? fmt(h) : '';
    hIn.value = Number.isFinite(w) ? fmt(w) : '';
    syncSize();
  });

  /* ---------- logo: any image -> PNG (max 1536 px long side) in the browser ---------- */
  const LOGO_TYPES = /^image\/(png|jpeg|jpg|pjpeg|webp|svg\+xml|gif)$/i;
  const LOGO_EXT = /\.(png|jpe?g|webp|svg|gif)$/i;
  function loadImg(src) {
    return new Promise((res, rej) => {
      const im = new Image();
      im.decoding = 'async';
      im.onload = () => res(im);
      im.onerror = () => rej(new Error('image'));
      im.src = src;
    });
  }
  function canvasBlob(img, w, h, type = 'image/png') {
    const c = document.createElement('canvas');
    c.width = w;
    c.height = h;
    const ctx = c.getContext('2d');
    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = 'high';
    ctx.drawImage(img, 0, 0, w, h);
    return new Promise((res, rej) => c.toBlob((b) => (b ? res(b) : rej(new Error('toBlob'))), type));
  }
  function thumbData(img, w, h) {
    const s = Math.min(1, 160 / Math.max(w, h));
    const c = document.createElement('canvas');
    c.width = Math.max(1, Math.round(w * s));
    c.height = Math.max(1, Math.round(h * s));
    c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
    try { return c.toDataURL('image/png'); } catch (e) { return ''; }
  }
  async function svgSource(file) {
    const txt = await file.text();
    const doc = new DOMParser().parseFromString(txt, 'image/svg+xml');
    const svg = doc.documentElement;
    if (!svg || svg.nodeName.toLowerCase() !== 'svg' || doc.getElementsByTagName('parsererror').length) throw new Error('svg');
    const dim = (a) => { const v = svg.getAttribute(a) || ''; return /%/.test(v) ? NaN : parseFloat(v); };
    let vw = dim('width');
    let vh = dim('height');
    const vb = (svg.getAttribute('viewBox') || '').trim().split(/[\s,]+/).map(Number);
    const hasVb = vb.length === 4 && vb[2] > 0 && vb[3] > 0;
    if (hasVb && !(vw > 0 && vh > 0)) { vw = vb[2]; vh = vb[3]; }
    if (!(vw > 0 && vh > 0)) { vw = 1024; vh = 1024; }
    if (!hasVb) svg.setAttribute('viewBox', `0 0 ${vw} ${vh}`);
    const s = MAX_LOGO_PX / Math.max(vw, vh); // vector: always render at the full 1536 px long side
    const w = Math.max(1, Math.round(vw * s));
    const h = Math.max(1, Math.round(vh * s));
    svg.setAttribute('width', String(w));
    svg.setAttribute('height', String(h));
    const src = URL.createObjectURL(new Blob([new XMLSerializer().serializeToString(svg)], { type: 'image/svg+xml' }));
    return { src, w, h };
  }
  async function toPng(file) {
    const isSvg = /svg/i.test(file.type) || /\.svg$/i.test(file.name);
    let src;
    let w;
    let h;
    if (isSvg) ({ src, w, h } = await svgSource(file));
    else src = URL.createObjectURL(file);
    try {
      const img = await loadImg(src);
      if (!isSvg) {
        const nw = img.naturalWidth;
        const nh = img.naturalHeight;
        if (!nw || !nh) throw new Error('size');
        const s = Math.min(1, MAX_LOGO_PX / Math.max(nw, nh));
        w = Math.max(1, Math.round(nw * s));
        h = Math.max(1, Math.round(nh * s));
      }
      let blob = await canvasBlob(img, w, h);
      for (let i = 0; i < 4 && blob.size > MAX_LOGO_BYTES; i++) {
        w = Math.max(1, Math.round(w * 0.75));
        h = Math.max(1, Math.round(h * 0.75));
        blob = await canvasBlob(img, w, h);
      }
      if (blob.size > MAX_LOGO_BYTES) throw new Error('big');
      return { blob, w, h, thumbData: thumbData(img, w, h) };
    } finally {
      URL.revokeObjectURL(src);
    }
  }
  function setLogo(L) {
    if (S.logo && S.logo.thumb && S.logo.thumb.indexOf('blob:') === 0) URL.revokeObjectURL(S.logo.thumb);
    S.logo = L;
    if (L) {
      logoImg.src = L.thumb || L.thumbData || '';
      logoName.textContent = L.name || 'Your logo';
      logoInfo.textContent = 'Added to every design';
    }
    logoRow.hidden = !L;
    drop.hidden = !!L;
  }
  async function takeLogo(file) {
    showErr('', logoErr);
    if (!(LOGO_TYPES.test(file.type || '') || LOGO_EXT.test(file.name || ''))) { showErr('Please choose a PNG, JPG, SVG, WEBP or GIF file.', logoErr); return; }
    if (file.size > MAX_SOURCE_BYTES) { showErr('That file is too big. Please use one under 30 MB.', logoErr); return; }
    drop.classList.add('is-busy');
    try {
      const out = await toPng(file);
      setLogo({ blob: out.blob, w: out.w, h: out.h, name: file.name, id: null, thumb: URL.createObjectURL(out.blob), thumbData: out.thumbData });
      track('ardor_banner_ai_logo', {});
    } catch (e) {
      showErr("We couldn't read that file. Try saving your logo as a PNG or JPG.", logoErr);
    }
    drop.classList.remove('is-busy');
  }
  fileIn.addEventListener('change', () => {
    const f = fileIn.files && fileIn.files[0];
    if (f) takeLogo(f);
    fileIn.value = '';
  });
  ['dragenter', 'dragover'].forEach((t) => drop.addEventListener(t, () => drop.classList.add('is-over')));
  ['dragleave', 'drop'].forEach((t) => drop.addEventListener(t, () => drop.classList.remove('is-over')));
  $('[data-abi-logo-remove]').addEventListener('click', () => {
    setLogo(null);
    showErr('', logoErr);
    fileIn.focus();
  });
  async function uploadLogo() {
    const L = S.logo;
    if (!L) return '';
    if (L.id) return L.id;
    if (!L.blob) throw { message: 'Please add your logo again.' };
    const fd = new FormData();
    fd.append('file', L.blob, 'logo.png');
    fd.append('visitor', visitor);
    const j = await api('/api/banner/logo', fd, 60000);
    if (!j.ok || !j.logoId) throw j;
    L.id = j.logoId;
    return j.logoId;
  }

  /* ---------- wording + style ---------- */
  function syncCount(key, el) {
    const c = $(`[data-abi-count="${key}"]`);
    if (!c) return;
    const n = el.value.length;
    c.textContent = `${n}/${LIMITS[key]}`;
    c.classList.toggle('is-near', n >= LIMITS[key] - 5);
  }
  Object.keys(lineIns).forEach((k) => {
    lineIns[k].addEventListener('input', () => {
      syncCount(k, lineIns[k]);
      if (k === 'headline' && clean(lineIns[k].value)) { setInvalid(lineIns[k], false); showErr('', headErr); }
      showErr('');
    });
  });
  notesIn.addEventListener('input', () => syncCount('notes', notesIn));

  function setStyle(st) {
    S.style = STYLES[st] ? st : 'bold';
    styleBtns.forEach((b) => {
      const on = b.dataset.style === S.style;
      b.setAttribute('aria-checked', String(on));
      b.tabIndex = on ? 0 : -1;
    });
  }
  styleBtns.forEach((b) => {
    b.addEventListener('click', () => setStyle(b.dataset.style));
    b.addEventListener('keydown', (e) => {
      if (!['ArrowRight', 'ArrowLeft', 'ArrowDown', 'ArrowUp'].includes(e.key)) return;
      e.preventDefault();
      const i = styleBtns.indexOf(b);
      const n = styleBtns[(i + (e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : -1) + styleBtns.length) % styleBtns.length];
      setStyle(n.dataset.style);
      n.focus();
    });
  });

  function readForm(show) {
    const { w, h } = readSize();
    let first = null;
    const badW = !validFt(w);
    const badH = !validFt(h);
    setInvalid(wIn, badW);
    setInvalid(hIn, badH);
    if (badW || badH) {
      if (show) showErr('Enter a width and height between 1 and 100 feet.', sizeErr);
      first = badW ? wIn : hIn;
    }
    const headline = clean(lineIns.headline.value).slice(0, LIMITS.headline);
    setInvalid(lineIns.headline, !headline);
    if (!headline) {
      if (show) showErr('Type the main words for your banner.', headErr);
      first = first || lineIns.headline;
    }
    if (first) {
      if (show) { first.focus({ preventScroll: true }); first.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
      return null;
    }
    const lines = { headline };
    const sub = clean(lineIns.subline.value).slice(0, LIMITS.subline);
    const det = clean(lineIns.details.value).slice(0, LIMITS.details);
    if (sub) lines.subline = sub;
    if (det) lines.details = det;
    return { w: round2(w), h: round2(h), style: S.style, notes: clean(notesIn.value).slice(0, LIMITS.notes), lines, hasLogo: !!S.logo };
  }

  /* ---------- busy states ---------- */
  function setBusyUi(on) {
    goBtn.disabled = on || S.off;
    goLabel.textContent = on ? 'Designing…' : 'Design my banner';
    againBtn.disabled = on;
    editBtn.disabled = on;
    $$('button, input', grid).forEach((el) => { el.disabled = on; });
  }
  let genTimer = 0;
  function placeholder(ar) {
    const c = document.createElement('div');
    c.className = 'abi__card is-loading';
    c.setAttribute('aria-hidden', 'true');
    c.innerHTML = `<div class="abi__frame" style="--ar:${ar}"><span class="abi__skel" style="--art:${clampAr(ar)}"><i></i><i></i><i></i></span></div><div class="abi__card-actions"><span class="abi__skel-btn"></span><span class="abi__skel-btn"></span></div>`;
    return c;
  }
  function startGenLoading(v) {
    S.busy = true;
    setBusyUi(true);
    results.hidden = false;
    loading.hidden = false;
    againRow.hidden = true;
    fineEl.hidden = true;
    echo.textContent = v.lines.headline;
    metaEl.textContent = `${sizeLabel(v.w, v.h)} · ${STYLES[v.style]}`;
    const ar = v.w / v.h;
    grid.dataset.shape = shapeOf(ar);
    grid.setAttribute('aria-busy', 'true');
    grid.innerHTML = '';
    for (let i = 0; i < 4; i++) grid.appendChild(placeholder(ar));
    const steps = GEN_STEPS.filter((m) => !m[3] || (m[3] === 'logo' && v.hasLogo));
    const t0 = Date.now();
    let last = -1;
    const tick = () => {
      const t = (Date.now() - t0) / 1000;
      bar.style.width = `${Math.min(95, 100 * (1 - Math.exp(-t / 36)))}%`;
      let k = 0;
      steps.forEach((m, i) => { if (t >= m[0]) k = i; });
      if (k === last) return;
      last = k;
      statusEl.textContent = steps[k][1];
      stepEls.forEach((li, i) => {
        li.classList.toggle('is-done', i < steps[k][2]);
        li.classList.toggle('is-on', i === steps[k][2]);
      });
    };
    clearInterval(genTimer);
    tick();
    genTimer = setInterval(tick, 250);
  }
  function stopGenLoading() {
    clearInterval(genTimer);
    S.busy = false;
    setBusyUi(false);
    loading.hidden = true;
    bar.style.width = '0';
    againRow.hidden = false;
    fineEl.hidden = false;
    grid.removeAttribute('aria-busy');
  }
  function cardBusy(card, title, sub, slow) {
    const o = $('.abi__busy', card);
    const fill = $('.abi__busy-bar i', card);
    $('.abi__busy-t', card).textContent = title;
    $('.abi__busy-s', card).textContent = sub;
    o.hidden = false;
    card.classList.add('is-busy');
    const t0 = Date.now();
    const tm = setInterval(() => { fill.style.width = `${Math.min(95, 100 * (1 - Math.exp(-(Date.now() - t0) / 1000 / slow)))}%`; }, 250);
    return () => { clearInterval(tm); o.hidden = true; card.classList.remove('is-busy'); fill.style.width = '0'; };
  }
  function cardErr(card, msg) { const el = card && $('.abi__cerr', card); if (el) showErr(msg, el); }
  const findCard = (id) => grid.querySelector(`.abi__card[data-id="${window.CSS && CSS.escape ? CSS.escape(id) : id}"]`);

  /* ---------- busy edges (same check as the banner builder, ardor-banner-layers.js) ---------- */
  const EDGE_BUSY = 2.5;
  // How streaky a design's stretched ends will look. Looks at the outer 2% of each edge that gets stretched,
  // sampled about 96 steps along the edge, and measures change in both directions: plain colors, smooth
  // gradients and stripes that already run straight off the edge score near 0; photos, busy textures and
  // text or shapes cut by the edge score high. Returns { a, b, score, busy } (a = left/top, b = right/bottom).
  function edgeBusy(img, wide) {
    var iw = img.naturalWidth || img.width, ih = img.naturalHeight || img.height;
    if (!iw || !ih) return null;
    var L = wide ? ih : iw, st = Math.max(1, L / 96);
    var n = Math.max(16, Math.round(L / st)), d = Math.max(4, Math.round((wide ? iw : ih) * 0.02 / st)), depth = d * st;
    var cw = wide ? d : n, ch = wide ? n : d, res = [];
    for (var s = 0; s < 2; s++) {
      var c = document.createElement('canvas'); c.width = cw; c.height = ch;
      var x = c.getContext('2d', { willReadFrequently: true });
      x.imageSmoothingEnabled = true; x.imageSmoothingQuality = 'high';
      if (wide) x.drawImage(img, s ? iw - depth : 0, 0, depth, ih, 0, 0, cw, ch);
      else x.drawImage(img, 0, s ? ih - depth : 0, iw, depth, 0, 0, cw, ch);
      var p = x.getImageData(0, 0, cw, ch).data;
      // per block along the edge (8 blocks): mean change along the edge and across it, max over R, G, B
      var B = 8, al = new Float64Array(B), ac = new Float64Array(B), na = new Float64Array(B), nc = new Float64Array(B);
      for (var yy = 0; yy < ch; yy++) for (var xx = 0; xx < cw; xx++) {
        var i = (yy * cw + xx) * 4, along = wide ? yy : xx, blk = Math.min(B - 1, Math.floor(along * B / n));
        if (xx + 1 < cw) {
          var dx = Math.max(Math.abs(p[i] - p[i + 4]), Math.abs(p[i + 1] - p[i + 5]), Math.abs(p[i + 2] - p[i + 6]));
          if (wide) { ac[blk] += dx; nc[blk]++; } else { al[blk] += dx; na[blk]++; }
        }
        if (yy + 1 < ch) {
          var j = i + cw * 4, dy = Math.max(Math.abs(p[i] - p[j]), Math.abs(p[i + 1] - p[j + 1]), Math.abs(p[i + 2] - p[j + 2]));
          if (wide) { al[blk] += dy; na[blk]++; } else { ac[blk] += dy; nc[blk]++; }
        }
      }
      var sum = 0, top = 0;
      for (var k = 0; k < B; k++) {
        var v = Math.sqrt((na[k] ? al[k] / na[k] : 0) * (nc[k] ? ac[k] / nc[k] : 0));
        sum += v; if (v > top) top = v;
      }
      res.push(Math.max(sum / B, top * 0.5));
    }
    var score = Math.max(res[0], res[1]);
    return { a: res[0], b: res[1], score: score, busy: score > EDGE_BUSY };
  }


  /* ---------- end previews (same drawing as the banner builder's extend(), ardor-banner-layers.js) ---------- */
  // Draws the design at the banner's real shape with its ends filled, stretched (as the builder does by default)
  // or smooth (&ends=smooth), so the customer can pick before the print version is made. size = preview short side.
  function mkC(w, h) { const c = document.createElement('canvas'); c.width = Math.max(1, Math.round(w)); c.height = Math.max(1, Math.round(h)); return c; }
  function composeEnds(img, B, smooth, size) {
    const wide = B > 1, nw = img.naturalWidth || img.width, nh = img.naturalHeight || img.height;
    const k = Math.min(1, size / (wide ? nh : nw));
    const src = mkC(nw * k, nh * k), sx0 = src.getContext('2d');
    sx0.imageSmoothingEnabled = true; sx0.imageSmoothingQuality = 'high'; sx0.drawImage(img, 0, 0, src.width, src.height);
    const iw0 = src.width, ih0 = src.height;
    let cw, ch;
    if (wide) { ch = ih0; cw = Math.round(ih0 * B); } else { cw = iw0; ch = Math.round(iw0 / B); }
    const iw = wide ? Math.round(iw0 * ch / ih0) : cw, ih = wide ? ch : Math.round(ih0 * cw / iw0);
    const ox = wide ? Math.round((cw - iw) / 2) : 0, oy = wide ? 0 : Math.round((ch - ih) / 2);
    const cv = mkC(cw, ch), x = cv.getContext('2d');
    x.imageSmoothingEnabled = true; x.imageSmoothingQuality = 'high';
    const A = wide ? ['l', 0, 0, ox, ch, 'r', ox + iw, 0, cw - ox - iw, ch] : ['t', 0, 0, cw, oy, 'b', 0, oy + ih, cw, ch - oy - ih];
    for (let q = 0; q < 10; q += 5) (smooth ? soften : side)(x, src, iw0, ih0, A[q], A[q + 1], A[q + 2], A[q + 3], A[q + 4]);
    x.drawImage(src, ox, oy, iw, ih);
    if (smooth) {
      const f = Math.max(2, Math.round((wide ? iw : ih) * 0.05));
      if (wide) { soften(x, src, iw0, ih0, 'l', ox, 0, f, ch, 1); soften(x, src, iw0, ih0, 'r', ox + iw - f, 0, f, ch, 1); }
      else { soften(x, src, iw0, ih0, 't', 0, oy, cw, f, 1); soften(x, src, iw0, ih0, 'b', 0, oy + ih - f, cw, f, 1); }
    }
    return cv;
  }
  // soft fill for one side: the outer 6% of the design averaged into 6 steps along the edge, then
  // stretched smoothly over the side. feather = 1 draws it over the design's own edge, fading out inward.
  function soften(x, img, iw0, ih0, where, dx, dy, dw, dh, feather) {
    if (dw < 1 || dh < 1) return;
    var horiz = where === 'l' || where === 'r', band = Math.max(1, Math.round((horiz ? iw0 : ih0) * 0.06));
    var mid = horiz ? mkC(1, 64) : mkC(64, 1), mx = mid.getContext('2d');
    mx.imageSmoothingEnabled = true; mx.imageSmoothingQuality = 'high';
    if (where === 'l') mx.drawImage(img, 0, 0, band, ih0, 0, 0, 1, 64);
    if (where === 'r') mx.drawImage(img, iw0 - band, 0, band, ih0, 0, 0, 1, 64);
    if (where === 't') mx.drawImage(img, 0, 0, iw0, band, 0, 0, 64, 1);
    if (where === 'b') mx.drawImage(img, 0, ih0 - band, iw0, band, 0, 0, 64, 1);
    var small = horiz ? mkC(1, 6) : mkC(6, 1), smx = small.getContext('2d');
    smx.imageSmoothingEnabled = true; smx.imageSmoothingQuality = 'high';
    smx.drawImage(mid, 0, 0, small.width, small.height);
    var soft = mkC(dw, dh), so = soft.getContext('2d');
    so.imageSmoothingEnabled = true; so.imageSmoothingQuality = 'high';
    so.drawImage(small, 0, 0, dw, dh);
    if (feather) {
      var g = where === 'l' ? so.createLinearGradient(0, 0, dw, 0) : where === 'r' ? so.createLinearGradient(dw, 0, 0, 0)
        : where === 't' ? so.createLinearGradient(0, 0, 0, dh) : so.createLinearGradient(0, dh, 0, 0);
      g.addColorStop(0, 'rgba(0,0,0,1)'); g.addColorStop(1, 'rgba(0,0,0,0)');
      so.globalCompositeOperation = 'destination-in'; so.fillStyle = g; so.fillRect(0, 0, dw, dh);
    }
    x.drawImage(soft, dx, dy);
  }
  function side(x, img, iw0, ih0, where, dx, dy, dw, dh) {
    if (dw < 1 || dh < 1) return;
    var horiz = where === 'l' || where === 'r', n = Math.max(1, Math.min(4, horiz ? iw0 : ih0));
    var line = horiz ? mkC(1, dh) : mkC(dw, 1), lx = line.getContext('2d');
    lx.imageSmoothingEnabled = true; lx.imageSmoothingQuality = 'high';
    if (where === 'l') lx.drawImage(img, 0, 0, n, ih0, 0, 0, 1, dh);
    if (where === 'r') lx.drawImage(img, iw0 - n, 0, n, ih0, 0, 0, 1, dh);
    if (where === 't') lx.drawImage(img, 0, 0, iw0, n, 0, 0, dw, 1);
    if (where === 'b') lx.drawImage(img, 0, ih0 - n, iw0, n, 0, 0, dw, 1);
    var sharp = mkC(dw, dh), sx = sharp.getContext('2d');
    sx.imageSmoothingEnabled = false;
    sx.drawImage(line, 0, 0, dw, dh);
    var len = horiz ? dh : dw, k = Math.max(2, Math.round(len / 40));
    var small = horiz ? mkC(1, Math.max(2, Math.round(dh / k))) : mkC(Math.max(2, Math.round(dw / k)), 1), smx = small.getContext('2d');
    smx.imageSmoothingEnabled = true; smx.imageSmoothingQuality = 'high';
    smx.drawImage(line, 0, 0, small.width, small.height);
    var soft = mkC(dw, dh), so = soft.getContext('2d');
    so.imageSmoothingEnabled = true; so.imageSmoothingQuality = 'high';
    so.drawImage(small, 0, 0, dw, dh);
    var fade = Math.max(1, Math.min(horiz ? dw : dh, len * 0.3)), g;
    if (where === 'l') g = so.createLinearGradient(dw, 0, dw - fade, 0);
    else if (where === 'r') g = so.createLinearGradient(0, 0, fade, 0);
    else if (where === 't') g = so.createLinearGradient(0, dh, 0, dh - fade);
    else g = so.createLinearGradient(0, 0, 0, fade);
    g.addColorStop(0, 'rgba(0,0,0,0)'); g.addColorStop(1, 'rgba(0,0,0,1)');
    so.globalCompositeOperation = 'destination-in'; so.fillStyle = g; so.fillRect(0, 0, dw, dh);
    sx.drawImage(soft, 0, 0);
    x.drawImage(sharp, dx, dy);
  }

  /* ---------- "How should we fill the ends?" (busy designs on banners wider than 3:1 or taller than 1:3) ---------- */
  function askEnds(card, img) {
    if (S.busy || !S.batch) return;
    let panel = $('.abi__ends', card);
    if (panel) { panel.hidden = false; card.classList.add('is-asking'); $('[data-ends="smooth"]', panel).focus(); return; }
    const b = S.batch, real = b.w / b.h, wide = real > img.w / img.h;
    const k = `abi-ends-${++uid}`;
    panel = document.createElement('div');
    panel.className = 'abi__ends';
    panel.setAttribute('role', 'group');
    panel.setAttribute('aria-labelledby', k);
    panel.innerHTML = `
      <p class="abi__ends-t" id="${k}"><b>How should we fill the ends?</b></p>
      <div class="abi__ends-opts">
        <button type="button" class="abi__endopt is-rec" data-ends="smooth"><span class="abi__endpic"></span><b>Smooth ends</b><small>A soft blend of the edge colors. Recommended</small></button>
        <button type="button" class="abi__endopt" data-ends="stretch"><span class="abi__endpic"></span><b>Stretched ends</b><small>The edges stretched out as they are</small></button>
      </div>
      <button type="button" class="abi__ends-back">Pick another design</button>`;
    $('.abi__ends-t', panel).append(` Your ${sizeLabel(b.w, b.h)} banner is ${wide ? 'wider' : 'taller'} than this design, so we fill the ${wide ? 'left and right' : 'top and bottom'} ends from its edges. Its edges are busy, so stretched ends may look streaky.`);
    const im = $('.abi__img', card);
    [['smooth', true], ['stretch', false]].forEach(([key, smooth]) => {
      try { $(`[data-ends="${key}"] .abi__endpic`, panel).appendChild(composeEnds(im, real, smooth, 220)); } catch (e) { /* preview not drawable: the labels still explain it */ }
      $(`[data-ends="${key}"]`, panel).addEventListener('click', () => { closeEnds(card); track('ardor_banner_ai_ends', { ends: key }); useDesign(img.id, key); });
    });
    $('.abi__ends-back', panel).addEventListener('click', () => { closeEnds(card); $('[data-act="use"]', card).focus({ preventScroll: true }); });
    $('.abi__card-actions', card).before(panel);
    card.classList.add('is-asking');
    $('[data-ends="smooth"]', panel).focus({ preventScroll: true });
    panel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }
  function closeEnds(card) { const p = $('.abi__ends', card); if (p) p.hidden = true; card.classList.remove('is-asking'); }

  /* ---------- results ---------- */
  let uid = 0;
  function cardFor(img, i, fixed) {
    const b = S.batch;
    const real = b.w / b.h;
    const art = img.w > 0 && img.h > 0 ? img.w / img.h : clampAr(real);
    const ext = Math.abs(real - art) / art > 0.03;
    const flagged = !!(img.check && img.check.ok === false);
    const n = i + 1;
    const k = `abi-fix-${++uid}`;
    const card = document.createElement('article');
    card.className = `abi__card${flagged ? ' is-flagged' : ''}`;
    card.setAttribute('role', 'listitem');
    card.setAttribute('aria-label', `Design ${n}`);
    card.dataset.id = img.id;
    const extCls = ext ? ` is-ext ${real > art ? 'is-ext-w' : 'is-ext-h'}` : '';
    const f = real > art ? art / real : real / art; // share of the banner the AI design covers
    card.innerHTML = `
      <div class="abi__frame${extCls}" style="--ar:${real};--f:${f}">
        <img class="abi__img" alt="" decoding="async">
        ${ext ? '<span class="abi__ext abi__ext--a" aria-hidden="true"></span><span class="abi__ext abi__ext--b" aria-hidden="true"></span>' : ''}
        ${fixed ? '<span class="abi__badge">Fixed</span>' : ''}
      </div>
      ${ext ? '<p class="abi__extnote"></p>' : ''}
      ${flagged ? '<p class="abi__flag"><svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3.5 2.5 20h19L12 3.5zM12 10v4.5M12 17.5v.01"/></svg><span>This one may have a spelling or logo mistake — use Fix a word or pick another.</span></p>' : ''}
      <p class="abi__cerr" role="alert" hidden></p>
      <div class="abi__card-actions">
        <button type="button" class="ws-btn abi__use" data-act="use">Use this design<span class="abi__vh"> (design ${n})</span><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg></button>
        <button type="button" class="ws-btn ws-btn--ghost abi__fixbtn" data-act="fix" aria-expanded="false" aria-controls="${k}">Fix a word<span class="abi__vh"> (design ${n})</span></button>
      </div>
      <form class="abi__fix" id="${k}" hidden novalidate>
        <label class="abi__flabel" for="${k}-in">What should we fix?</label>
        <div class="abi__fix-row">
          <input id="${k}-in" class="abi__input" type="text" maxlength="${LIMITS.fix}" autocomplete="off">
          <button type="submit" class="ws-btn ws-btn--ghost">Fix it</button>
        </div>
        <small class="abi__fix-left"></small>
      </form>
      <div class="abi__busy" hidden><span class="abi__spin" aria-hidden="true"></span><b class="abi__busy-t"></b><small class="abi__busy-s"></small><span class="abi__busy-bar" aria-hidden="true"><i></i></span></div>`;
    const im = $('.abi__img', card);
    im.alt = `Banner design ${n}: ${b.lines.headline}`;
    im.addEventListener('load', () => {
      card.classList.add('is-in');
      if (!ext) return;
      let eb = null;
      try { eb = edgeBusy(im, real > art); } catch (e) { /* image not readable: keep the plain note */ }
      if (!eb || !eb.busy) return;
      card.dataset.busy = '1';
      const note = $('.abi__extnote', card);
      note.classList.add('is-warn');
      note.textContent = `Busy edges: the stretched ${real > art ? 'left and right' : 'top and bottom'} ends of this design may look streaky. When you use it, you can pick smooth ends instead.`;
    });
    im.addEventListener('error', () => card.classList.add('is-broken'));
    if (ext) im.crossOrigin = 'anonymous'; // lets the busy-edge check read the pixels (the worker sends CORS *)
    im.src = img.url;
    if (ext) {
      $('.abi__frame', card).style.setProperty('--img', `url("${String(img.url).replace(/["\\\n]/g, '')}")`);
      $('.abi__extnote', card).textContent = `We'll extend the background to your full ${sizeLabel(b.w, b.h)} size.`;
    }
    const fixForm = $('.abi__fix', card);
    const fixIn = $('input', fixForm);
    const fixBtn = $('[data-act="fix"]', card);
    fixIn.placeholder = 'e.g. Change "Snohomsh" to "Snohomish"';
    $('.abi__fix-left', card).textContent = fixesText();
    $('[data-act="use"]', card).addEventListener('click', () => (card.dataset.busy ? askEnds(card, img) : useDesign(img.id)));
    fixBtn.addEventListener('click', () => {
      const open = fixForm.hidden;
      fixForm.hidden = !open;
      fixBtn.setAttribute('aria-expanded', String(open));
      if (!open) return;
      const wrong = img.check && Array.isArray(img.check.wrong) ? img.check.wrong.find((x) => x && x.expected && x.seen) : null;
      if (wrong && !fixIn.value) fixIn.value = `Change "${wrong.seen}" to "${wrong.expected}"`;
      fixIn.focus();
    });
    fixForm.addEventListener('submit', (e) => { e.preventDefault(); fixDesign(img.id, fixIn.value); });
    if (S.busy) $$('button, input', card).forEach((el) => { el.disabled = true; });
    return card;
  }
  function renderResults() {
    const b = S.batch;
    if (!b || !b.images || !b.images.length) { results.hidden = true; return; }
    results.hidden = false;
    loading.hidden = true;
    againRow.hidden = false;
    fineEl.hidden = false;
    echo.textContent = b.lines.headline;
    metaEl.textContent = `${sizeLabel(b.w, b.h)} · ${STYLES[b.style] || ''}`;
    grid.dataset.shape = shapeOf(b.w / b.h);
    grid.innerHTML = '';
    b.images.forEach((img, i) => grid.appendChild(cardFor(img, i, !!img.fixedFrom)));
    const bad = b.images.filter((x) => x.check && x.check.ok === false).length;
    if (bad && bad === b.images.length) statusEl.textContent = 'These may have a mistake. Use Fix a word or make another set.';
    else statusEl.textContent = b.images.length > 1 ? `${b.images.length} designs ready. Pick your favorite.` : 'Your design is ready.';
  }
  function remember() {
    const L = S.logo;
    sset(LAST_KEY, {
      at: Date.now(),
      batch: S.batch,
      form: { w: S.w, h: S.h, style: S.style, notes: notesIn.value, headline: lineIns.headline.value, subline: lineIns.subline.value, details: lineIns.details.value },
      logo: L && L.id ? { id: L.id, name: L.name, w: L.w, h: L.h, thumbData: L.thumbData } : null
    });
  }

  /* ---------- generate / fix / final ---------- */
  async function generate() {
    if (S.busy || S.off) return;
    const v = readForm(true);
    if (!v) return;
    if (!S.hasEmail && S.bannersLeft === 0) { S.pending = { kind: 'generate', run: generate }; openGate(); return; }
    showErr('');
    const prev = S.batch;
    startGenLoading(v);
    results.scrollIntoView({ behavior: 'smooth', block: 'start' });
    let logoId = '';
    if (v.hasLogo) {
      try {
        logoId = await uploadLogo();
      } catch (j) {
        stopGenLoading();
        S.batch = prev;
        renderResults();
        showErr((j && j.message) || "We couldn't upload your logo. Try another file, or remove it and try again.");
        form.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
    }
    const token = await botToken();
    const body = withEmail({ visitor, token, widthFt: v.w, heightFt: v.h, style: v.style, styleNotes: v.notes, lines: v.lines });
    if (logoId) body.logoId = logoId;
    const j = await api('/api/banner/generate', body);
    stopGenLoading();
    if (j.bannersLeft != null) S.bannersLeft = j.bannersLeft;
    if (j.fixesLeft != null) S.fixesLeft = j.fixesLeft;
    if (!j.ok || !Array.isArray(j.images) || !j.images.length) {
      S.batch = prev;
      renderResults();
      if (j.error === 'need_email') {
        S.bannersLeft = 0;
        setQuota();
        S.pending = { kind: 'generate', run: generate };
        openGate();
        return;
      }
      showErr(j.message || "We couldn't make your designs this time. Please try again.");
      setQuota();
      form.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    if ('hasEmail' in j) S.hasEmail = !!j.hasEmail;
    S.batch = {
      batchId: j.batchId || '', aspect: j.aspect, clamped: !!j.clamped,
      w: v.w, h: v.h, style: v.style, notes: v.notes, lines: v.lines,
      logoId: logoId || null, images: j.images.slice(0, 8)
    };
    setQuota();
    renderResults();
    remember();
    h2.focus({ preventScroll: true });
    track('ardor_banner_ai_generated', { style: v.style, w: v.w, h: v.h, logo: !!logoId, shown: j.images.length });
  }

  async function fixDesign(id, text) {
    if (S.busy) return;
    const card = findCard(id);
    if (!card) return;
    const input = $('.abi__fix input', card);
    const fix = clean(text).slice(0, LIMITS.fix);
    if (fix.length < 2) { cardErr(card, 'Tell us what to fix, like: Change "Snohomsh" to "Snohomish".'); input.focus(); return; }
    if (!S.hasEmail && S.fixesLeft === 0) { S.pending = { kind: 'fix', run: () => fixDesign(id, fix) }; openGate(); return; }
    cardErr(card, '');
    S.busy = true;
    setBusyUi(true);
    const done = cardBusy(card, 'Fixing it…', 'Redoing just that part', 14);
    statusEl.textContent = 'Fixing your design…';
    const token = await botToken();
    const j = await api('/api/banner/fix', withEmail({ visitor, token, imageId: id, fix }));
    done();
    S.busy = false;
    setBusyUi(false);
    if (j.fixesLeft != null) S.fixesLeft = j.fixesLeft;
    if (!j.ok || !Array.isArray(j.images) || !j.images.length) {
      setQuota();
      statusEl.textContent = '';
      if (j.error === 'need_email') { S.fixesLeft = 0; S.pending = { kind: 'fix', run: () => fixDesign(id, fix) }; openGate(); return; }
      cardErr(card, j.message || 'That fix did not work. Please try again.');
      return;
    }
    const idx = S.batch.images.findIndex((x) => x.id === id);
    const next = Object.assign({}, j.images[0], { fixedFrom: id });
    S.batch.images[idx] = next;
    const fresh = cardFor(next, idx, true);
    card.replaceWith(fresh);
    setQuota();
    remember();
    statusEl.textContent = next.check && next.check.ok === false
      ? 'Here is your fixed design. It may still have a mistake, so check it closely.'
      : 'Here is your fixed design.';
    $('[data-act="use"]', fresh).focus({ preventScroll: true });
    track('ardor_banner_ai_fixed', { style: S.batch.style });
  }

  function validBox(lb) {
    return Array.isArray(lb) && lb.length === 4 && lb.every((n) => typeof n === 'number' && Number.isFinite(n)) ? lb.map((n) => Math.min(1, Math.max(0, n))) : null;
  }
  function handoffUrl(aiId, w, h, logoId, lb) {
    let u = `${BUILDER}${BUILDER.indexOf('?') === -1 ? '?' : '&'}ai=${enc(aiId)}&w=${fmt(w)}&h=${fmt(h)}`;
    if (logoId) {
      u += `&logo=${enc(logoId)}`;
      if (lb) u += `&lb=${lb.map((n) => n.toFixed(4)).join(',')}`;
    }
    return u;
  }
  async function useDesign(id, ends) {
    if (S.busy || !S.batch) return;
    const card = findCard(id);
    const b = S.batch;
    const img = b.images.find((x) => x.id === id);
    if (!card || !img) return;
    cardErr(card, '');
    S.busy = true;
    setBusyUi(true);
    const done = cardBusy(card, 'Making a sharp, print-ready version…', 'about 30–60 seconds', 25);
    statusEl.textContent = 'Making a sharp, print-ready version… about 30–60 seconds.';
    const token = await botToken();
    const j = await api('/api/banner/final', withEmail({ visitor, token, imageId: id }));
    if (j.finalsLeft != null) S.finalsLeft = j.finalsLeft;
    if (!j.ok || !j.image || !j.image.id) {
      done();
      S.busy = false;
      setBusyUi(false);
      statusEl.textContent = '';
      if (j.error === 'need_email') { S.pending = { kind: 'final', run: () => useDesign(id, ends) }; openGate(); return; }
      cardErr(card, j.message || "We couldn't make the print version. Please try again.");
      return;
    }
    const fin = j.image;
    const lb = validBox(fin.check && fin.check.logoBox) || validBox(img.check && img.check.logoBox);
    const url = handoffUrl(fin.id, b.w, b.h, b.logoId, lb) + (ends === 'smooth' ? '&ends=smooth' : '');
    sset(PICK_KEY, { ai: fin.id, url: fin.url, w: b.w, h: b.h, logo: b.logoId || null, lb, ends: ends || null, preview: id, lines: b.lines, style: b.style, at: Date.now() });
    remember();
    track('ardor_banner_ai_used', { style: b.style, w: b.w, h: b.h, logo: !!b.logoId, ends: ends || '' });
    $('.abi__busy-t', card).textContent = 'Opening the banner builder…';
    $('.abi__busy-s', card).textContent = '';
    statusEl.textContent = 'Opening the banner builder…';
    const ev = new CustomEvent('ardor:banner-ai-handoff', { bubbles: true, cancelable: true, detail: { url, image: fin, preview: img, batch: b } });
    if (root.dispatchEvent(ev)) { window.location.assign(url); return; }
    done();
    S.busy = false;
    setBusyUi(false);
  }

  form.addEventListener('submit', (e) => { e.preventDefault(); generate(); });
  againBtn.addEventListener('click', () => generate());
  editBtn.addEventListener('click', () => {
    form.scrollIntoView({ behavior: 'smooth', block: 'start' });
    setTimeout(() => lineIns.headline.focus({ preventScroll: true }), 350);
  });

  /* ---------- email unlock (same as the sticker generator: Shopify customer form into a hidden iframe) ---------- */
  function openGate() {
    showErr('', gateErr);
    gateEmail.value = email || '';
    if (gateN) gateN.textContent = String(S.emailBanners);
    if (gate.showModal) { try { gate.showModal(); } catch (e) { gate.setAttribute('open', ''); } }
    else gate.setAttribute('open', '');
    setTimeout(() => gateEmail.focus(), 60);
    track('ardor_banner_ai_gate_shown', {});
  }
  function closeGate() { if (gate.close) gate.close(); else gate.removeAttribute('open'); }
  $('[data-abi-gate-close]').addEventListener('click', closeGate);
  gate.addEventListener('click', (e) => { if (e.target === gate) closeGate(); });
  function customerForm() {
    let f = root.querySelector('form#abi-customer');
    if (!f) {
      f = document.createElement('form');
      f.id = 'abi-customer';
      f.method = 'post';
      f.action = '/contact#abi-customer';
      f.className = 'abi__customer';
      f.innerHTML = '<input type="hidden" name="form_type" value="customer"><input type="hidden" name="utf8" value="✓"><input type="hidden" name="contact[tags]" value="newsletter,ai-banner-generator,ardor-banner-builder"><input type="hidden" name="contact[email]" data-abi-customer-email>';
      root.appendChild(f);
    }
    return f;
  }
  function subscribe(addr) {
    const f = customerForm();
    const field = f.querySelector('[name="contact[email]"]');
    if (field) field.value = addr;
    f.target = 'abi-sink';
    try { if (f.requestSubmit) f.requestSubmit(); else f.submit(); } catch (e) { try { f.submit(); } catch (e2) { /* ignore */ } }
  }
  gateForm.addEventListener('submit', async (e) => {
    e.preventDefault();
    const addr = gateEmail.value.trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(addr)) { showErr('Please enter a valid email.', gateErr); gateEmail.focus(); return; }
    email = addr;
    store.set('wsIdeaEmail', addr);
    S.hasEmail = true;
    subscribe(addr);
    track('ardor_banner_ai_email', {});
    const q = await api(`/api/banner/quota?visitor=${enc(visitor)}&email=${enc(addr)}`);
    if (q.ok) {
      S.bannersLeft = q.bannersLeft;
      S.fixesLeft = q.fixesLeft;
      S.finalsLeft = q.finalsLeft;
      if (q.emailBanners) S.emailBanners = q.emailBanners;
    }
    setQuota();
    closeGate();
    const next = S.pending;
    S.pending = null;
    if (next && !(next.kind === 'generate' && S.bannersLeft === 0)) next.run();
  });

  /* ---------- start ---------- */
  Object.keys(lineIns).forEach((k) => syncCount(k, lineIns[k]));
  syncCount('notes', notesIn);
  const params = new URL(window.location.href).searchParams;
  const last = sget(LAST_KEY);
  if (last && last.form && Date.now() - (last.at || 0) < 36e5 * 24) {
    const f = last.form;
    lineIns.headline.value = f.headline || '';
    lineIns.subline.value = f.subline || '';
    lineIns.details.value = f.details || '';
    notesIn.value = f.notes || '';
    Object.keys(lineIns).forEach((k) => syncCount(k, lineIns[k]));
    syncCount('notes', notesIn);
    setStyle(f.style || 'bold');
    if (validFt(f.w) && validFt(f.h)) setSize(f.w, f.h);
    if (last.logo && last.logo.id) setLogo({ blob: null, id: last.logo.id, name: last.logo.name, w: last.logo.w, h: last.logo.h, thumb: last.logo.thumbData, thumbData: last.logo.thumbData });
    if (last.batch && last.batch.images && last.batch.images.length) { S.batch = last.batch; renderResults(); }
  }
  const pw = num(params.get('w'));
  const ph = num(params.get('h'));
  if (validFt(pw) && validFt(ph)) setSize(pw, ph);
  else syncSize();

  (async () => {
    const q = await api(`/api/banner/quota?visitor=${enc(visitor)}${email ? `&email=${enc(email)}` : ''}`, null, 20000);
    if (!q.ok) return;
    if (q.enabled === false) {
      S.off = true;
      goBtn.disabled = true;
      showErr('The banner generator is taking a short break. Please try again later.');
    }
    S.bannersLeft = q.bannersLeft;
    S.fixesLeft = q.fixesLeft;
    S.finalsLeft = q.finalsLeft;
    S.hasEmail = !!q.hasEmail;
    if (q.freeBanners) S.freeBanners = q.freeBanners;
    if (q.emailBanners) S.emailBanners = q.emailBanners;
    setQuota();
  })();
  if (SITEKEY) loadTurnstile();
})();
